import { routeHref } from '../../lib/links';
import { isHeroDark } from '../../lib/theme';
import { demoAttrs } from '../cta';
import { ARROW_ICON, icon, type IconName } from '../icons';
import { logo } from '../logo';

type MenuItem = readonly [to: string, iconName: IconName, title: string, summary: string];

const SOLUTIONS: readonly MenuItem[] = [
  ['#advisory', 'building', 'Advisory &amp; Valuation Firms', 'Governed workflows across offices'],
  ['#practices', 'listChecks', 'Property Tax Practices', 'More capacity, same methodology'],
  ['#cre-portfolios', 'layers', 'Enterprise CRE Portfolios', 'Visibility from organization to parcel'],
];
const COMPANY: readonly MenuItem[] = [
  ['/company', 'book', 'Our Thesis', 'Why ReTax360 exists'],
  ['/careers', 'code2', 'Careers', 'Build with us'],
  ['/contact', 'mail', 'Contact', 'Sales, general and careers'],
];
function ddItem(path: string, id: string, label: string, items: readonly MenuItem[]): string {
  return `<li class="has-dd">
    <a href="${routeHref(path)}" data-nav="${path}">${label}</a><button class="dd-btn" id="${id}-btn" aria-expanded="false" aria-controls="${id}-menu" aria-label="${label} menu">${icon('chevron')}</button>
    <div class="dd" id="${id}-menu" role="menu" aria-labelledby="${id}-btn">
      ${items.map(([to, i, b, s]) => `<a role="menuitem" href="${routeHref(to)}"><span class="ic">${icon(i)}</span><span><b>${b}</b><small>${s}</small></span></a>`).join('')}
    </div></li>`;
}
export function header(): string {
  return `
  <a class="skip" href="#main" data-skip>Skip to content</a>
  <header class="nav" id="top">
    <div class="wrap">
      <a class="logo" href="${routeHref('/')}" aria-label="ReTax360 home">${logo(isHeroDark() ? 'dark' : 'light')}</a>
      <nav aria-label="Primary">
        <ul class="nav-links">
          <li><a href="${routeHref('/platform')}" data-nav="/platform">Platform</a></li>
          ${ddItem(
            '/solutions',
            'dd-sol',
            'Solutions',
            SOLUTIONS.map(([a, i, b, s]) => ['/solutions' + a, i, b, s]),
          )}
          <li><a href="${routeHref('/customers')}" data-nav="/customers">Customers</a></li>
          <li><a href="${routeHref('/security')}" data-nav="/security">Security</a></li>
          <li><a href="${routeHref('/insights')}" data-nav="/insights">Insights</a></li>
          ${ddItem('/company', 'dd-co', 'Company', COMPANY)}
        </ul>
      </nav>
      <div class="nav-right">
        <a class="btn btn-primary btn-sm" ${demoAttrs('nav_book_enterprise_demo')}>Book an Enterprise Demo</a>
        <button class="burger" id="burger" aria-expanded="false" aria-controls="drawer" aria-label="Open menu">${icon('menu')}</button>
      </div>
    </div>
  </header>
  <div class="drawer" id="drawer" tabindex="-1" role="dialog" aria-modal="true" aria-label="Site menu" hidden>
    <nav aria-label="Mobile">
      <a href="${routeHref('/')}" data-nav="/">Home ${icon('arrow')}</a>
      <a href="${routeHref('/platform')}" data-nav="/platform">Platform ${icon('arrow')}</a>
      <a href="${routeHref('/solutions')}" data-nav="/solutions">Solutions ${icon('arrow')}</a>
      <div class="sub">${SOLUTIONS.map(([a, , b]) => `<a href="${routeHref('/solutions' + a)}">${b} ${icon('arrow')}</a>`).join('')}</div>
      <a href="${routeHref('/customers')}" data-nav="/customers">Customers ${icon('arrow')}</a>
      <a href="${routeHref('/security')}" data-nav="/security">Security ${icon('arrow')}</a>
      <a href="${routeHref('/insights')}" data-nav="/insights">Insights ${icon('arrow')}</a>
      <a href="${routeHref('/company')}" data-nav="/company">Company ${icon('arrow')}</a>
      <div class="sub"><a href="${routeHref('/careers')}" data-nav="/careers">Careers ${icon('arrow')}</a><a href="${routeHref('/contact')}" data-nav="/contact">Contact ${icon('arrow')}</a></div>
      <a class="btn btn-primary" ${demoAttrs('nav_book_enterprise_demo')}>Book an Enterprise Demo ${ARROW_ICON}</a>
    </nav>
  </div>`;
}
